import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
  AppConfigNewModal,
  // TemplateNewModal
} from '../../../modals';
import { AppConfigService } from '../../../services';
import { AuthenticationService } from 'src/modules/core/services';

@Component({
  selector: 'app-app-config-list',
  templateUrl: './app-config-list.component.html',
  styleUrls: ['./app-config-list.component.scss'],
})
export class AppConfigListComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  applicationConfigs: Array<any>;
  error;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'appConfigId',
        op: 'cn',
        data: '',
      },
    ],
  };

  constructor(
    private appConfigSvc: AppConfigService,
    private location: Location,
    private modalService: SuiModalService,
    private userSvc: AuthenticationService
  ) {
    this.filter = new AppFilter({ sidx: 'appConfigId', rows: 10 });
    this.getPage(1);
  }
  goBack() {
    this.location.back();
  }

  newConfig() {
    this.modalService
      .open(
        new AppConfigNewModal('Add Configuration', '', false, ModalSize.Tiny)
      )
      .onApprove((eq) => {})
      .onDeny(() => console.log('add certificate holder cancel'));
  }
  onEdit(event) {
    this.modalService
      .open(
        new AppConfigNewModal('Edit Configuration', event, true, ModalSize.Tiny)
      )
      .onApprove((eq) => {
        if (event.appConfigId === 'TWO_FACTOR_AUTH_ACTIVATION_DATE') {
          this.getPage(1);
          this.userSvc.signinEvent.next(true);
        } else {
          this.getPage(1);
        }
      })
      .onDeny(() => console.log('add certificate holder cancel'));
  }

  deleteTemplate() {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Application Configuration?',
          'Are you sure you want to delete this application configuration?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.appConfigSvc.getAppConfigs({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.totalItems = +res.records;
        this.rows = this.filter.rows;
        this.applicationConfigs = res['rows'];
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'appConfigId',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }
  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete App Config?',
          'Are you sure you want to delete this app config?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  delete(event: any): void {
    this.pending = true;
    this.error = null;
    this.appConfigSvc
      .deleteAppConfigs({ appConfigId: event.appConfigId })
      .subscribe(
        (res) => {
          this.pending = false;
          this.getPage(this.filter.page);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  ngOnInit(): void {}
}
